"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = RadioField;

var _react = _interopRequireDefault(require("react"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _formik = require("formik");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Form = require("../../../../domains/registration/onboarding/shared/styles/Form");

var _Radio = require("./Radio");

var _Radio2 = require("./Radio.styled");

var __jsx = _react["default"].createElement;
// TODO move FormFieldError to ui/components/form
var FormFieldErrorStyled = (0, _styledComponents["default"])(_Form.FormFieldError).withConfig({
  displayName: "RadioField__FormFieldErrorStyled",
  componentId: "p69vtm-0"
})(["margin-top:8px;"]);

function RadioField(_ref) {
  var name = _ref.name,
      label = _ref.label,
      description = _ref.description,
      options = _ref.options,
      direction = _ref.direction,
      onChange = _ref.onChange,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["name", "label", "description", "options", "direction", "onChange"]);

  var _useFormikContext = (0, _formik.useFormikContext)(),
      values = _useFormikContext.values,
      setValues = _useFormikContext.setValues;

  function handleOnChange(e, nativeOnChange) {
    if (onChange) onChange(e, values, setValues);
    nativeOnChange(e);
  }

  return __jsx(_formik.Field, {
    name: name
  }, function (_ref2) {
    var _ref2$field = _ref2.field,
        value = _ref2$field.value,
        field = (0, _objectWithoutProperties2["default"])(_ref2$field, ["value"]);
    return __jsx(_Radio2.Fieldset, props, __jsx(_Radio2.TopLabel, null, label), __jsx(_Radio2.Description, null, description), __jsx(_Radio2.RadioGroup, {
      $direction: direction
    }, options.map(function (option) {
      return __jsx(_Radio.Radio, (0, _extends2["default"])({}, field, {
        name: name,
        key: option.value,
        label: option.label,
        value: option.value,
        description: option.description,
        onChange: function onChange(e) {
          return handleOnChange(e, field.onChange);
        }
      }, option.attrs || {}));
    })), __jsx(FormFieldErrorStyled, {
      name: name
    }));
  });
}

RadioField.defaultProps = {
  direction: 'column'
};